/**
 * @flow
 * */
import { initialSectionState, initialSectionWithCountState } from 'store/reducers/initialStates';
import ACTION_TYPES from 'modules/Admin/ActivityLog/store/actions/types';
import type { ActivityLogState } from 'modules/Admin/ActivityLog/types';
import { ACTION_STATUSES } from 'lib/core/actionStatuses';
import type { Action } from 'lib/core/flow';

const initialOptionsState = () => ({
  status: null,
  error: null,
  roles: initialSectionState(),
  events: initialSectionState(),
  actions: initialSectionState()
});

const initialState = (): ActivityLogState => ({
  ...initialSectionWithCountState(),
  options: initialOptionsState()
});

const actionManager = {
  // Activity Log Table
  [ACTION_TYPES.FETCH_ACTIVITY_LOGS]: (state: ActivityLogState): ActivityLogState => ({
    ...state,
    status: ACTION_STATUSES.PENDING
  }),
  [ACTION_TYPES.SET_FETCH_ACTIVITY_LOGS_SUCCESS]: (state: ActivityLogState, payload): ActivityLogState => ({
    ...state,
    status: ACTION_STATUSES.SUCCEED,
    data: payload.data,
    totalCount: !payload.passTotalCount ? payload.totalCount : state.totalCount,
    error: null
  }),
  [ACTION_TYPES.SET_FETCH_ACTIVITY_LOGS_FAILURE]: (state: ActivityLogState, payload): ActivityLogState => ({
    ...state,
    status: ACTION_STATUSES.FAILED,
    error: payload.error
  }),
  [ACTION_TYPES.CLEAR_ACTIVITY_LOGS_STATE]: (state: ActivityLogState): ActivityLogState => ({
    ...initialState(),
    options: state.options
  })
};

export default (state: ActivityLogState = initialState(), action: Action) => {
  if (!actionManager[action.type]) {
    return state;
  }

  return actionManager[action.type](state, action.payload);
};
